import {
  GUEST_USER_PERMISSIONS_LIST,
  GUEST_USER_PERMISSIONS,
  ROLE_ADMIN,
  ROLE_CREATOR,
  ROLE_GUEST,
  ROLE_PUBLISHER
} from '../../../config/roles';
import * as PropTypes from 'prop-types';
import { useTranslate } from '@tolgee/react';

interface RolePermissionsProps {
  role: number;
  guestRoles: any;
}

const RolePermissions: React.FC<RolePermissionsProps> = ({
  role,
  guestRoles
}) => {
  const styles = {
    [ROLE_ADMIN]: ' badge-light-primary',
    [ROLE_CREATOR]: ' badge-light-success ',
    [ROLE_PUBLISHER]: ' badge-light-warning',
    [ROLE_GUEST]: ' badge-light'
  };
  const { t } = useTranslate();
  if (role === undefined || role == null) return <></>;

  if (role === ROLE_GUEST)
    return (
      <div className={`gap-2 d-flex flex-wrap`}>
        {GUEST_USER_PERMISSIONS_LIST.map((permission: string) => {
          if (guestRoles[permission as keyof typeof guestRoles] === true)
            return (
              <div
                key={permission}
                className={`badge py-3 px-4 fs-7 ${
                  styles[role as keyof typeof styles]
                }`}
                style={{ flexShrink: 0 }} // Prevent badge from shrinking
              >
                {t(
                  `config.roles.${
                    GUEST_USER_PERMISSIONS[
                      permission as keyof typeof GUEST_USER_PERMISSIONS
                    ].name
                  }`
                )}
              </div>
            );
          return null;
        })}
      </div>
    );
  return null;
};

export default RolePermissions;
RolePermissions.propTypes = {
  role: PropTypes.number,
  guestRoles: PropTypes.object
};
